// @ts-nocheck
import {QueryBatcher} from './batcher'
import type {ClientOptions} from './createClient'
import {GenqlError} from './error'
import type {GraphqlOperation} from './generateGraphqlOperation'

export interface CreateFetcher {
    (gql: GraphqlOperation, options?: import('./createClient').RequestOptions): Promise<any>
}

export type BatchOptions = {
    batchInterval?: number // ms
    maxBatchSize?: number
}

const DEFAULT_BATCH_OPTIONS = {
    maxBatchSize: 10,
    batchInterval: 40,
}

export const createFetcher = (
    {
        url,
        headers = {},
        fetcher,
        fetch: _fetch,
        batch = false,
        timeout,
        ...rest
    }: ClientOptions
): CreateFetcher => {
    if (!fetcher) {
        throw new Error('url or fetcher is required')
    }
    if (!batch) {
        return async (body, options) => {
            const json = await fetcher!(body, options)
            if (Array.isArray(json)) {
                return json.map((json) => {
                    if (json?.errors?.length) {
                        throw new GenqlError(json.errors || [], json.data)
                    }
                    return json.data
                })
            } else {
                if (json?.errors?.length) {
                    throw new GenqlError(json.errors || [], json.data)
                }
                return json.data
            }
        }
    }

    const batcher = new QueryBatcher(
        async (batchedQuery) => {
            // console.log(batchedQuery) // [{ query: 'query{user{age}}', variables: {} }, ...]
            const json = await fetcher!(batchedQuery)
            return json as any
        },
        batch === true ? DEFAULT_BATCH_OPTIONS : batch,
    )

    return async ({query, variables}) => {
        const json = await batcher.fetch(query, variables)
        if (json?.data) {
            return json.data
        }
        throw new Error(
            'Genql batch fetcher returned unexpected result ' + JSON.stringify(json),
        )
    }
}
